export default {
  getClusterDataMiddleware(state) {
      return state.clusterDataMiddleware
  },
  getReportsProjMiddleware(state) {
      return state.reportsProjMiddleware
  },
  getProjectsClustMiddleware(state){
    return state.projectsClustMiddleware
  },
  getExtractedDataBinaryMiddleware(state){
    return state.extractedDataBinaryMiddleware
  },
  getDrawCircuitMiddleware(state){
    return state.drawCircuitMiddleware
  },
  getRecommendCircuitMiddleware(state){
    return state.apiRecommendCircuitMiddleware
  },
  getNewTemplateMiddleware(state){
    return state.newTemplateMiddleware
  },
  getUsersSharingMiddleware(state) {
    return state.usersSharingMiddleware
  },
  getLastErrorMiddleware(state) {
    return state.lastErrorMiddleware
  },
  getTemplateDBMiddleware(state) {
    return state.templateDBMiddleware
  },
  getProjTemplListMiddleware(state) {
    return state.projTemplListMiddleware
  },
  getTemplListMiddleware(state) {
    return state.templListMiddleware
  },
	getResourceAccessRequestsMiddleware(state) {
    return state.resourceAccessRequestsMiddleware
  },
	getTotalIncomingPendingAccessRequestsMiddleware(state) {
    return state.totalIncomingPendingAccessRequestsMiddleware
  },
	getTotalPersonalPendingAccessRequestsMiddleware(state) {
    return state.totalPersonalPendingAccessRequestsMiddleware
  },
	getReportAccessTypeMiddleware(state){
		return state.reportAccessTypeMiddleware
	}
}
